export default __webpack_public_path__ + "static/media/Believer's Belt of the Purple Sun.0bc45f0d.jpg";